import { memo, useCallback } from 'react';
import dayjs from 'dayjs';

import InputField from '../../../common/fields/InputField';
import DateInputField from '../../../common/fields/DateInputField';
import SectionCard from './SectionCard';

export default memo(function ProfileSection({ formData, errors, onChange }) {
  const handleBioChange = useCallback((e) => onChange({ bio: e.target.value }), [onChange]);

  const handleVideoUrlChange = useCallback(
    (e) => onChange({ introVideoUrl: e.target.value }),
    [onChange],
  );

  const handleDobChange = useCallback((date) => onChange({ dob: date }), [onChange]);

  return (
    <SectionCard title="Profile Information">
      <div className="space-y-4">
        <DateInputField
          label="Date of Birth"
          value={formData.dob}
          minDate={dayjs().subtract(80, 'year')}
          maxDate={dayjs().subtract(18, 'year')}
          onChange={handleDobChange}
          disableFuture
          error={!!errors.dob}
          helperText={errors.dob}
        />
        <InputField
          label="Bio *"
          value={formData.bio}
          onChange={handleBioChange}
          multiline
          rows={4}
          error={!!errors.bio}
          helperText={errors.bio}
        />
        <InputField
          label="Intro Video URL"
          value={formData.introVideoUrl}
          onChange={handleVideoUrlChange}
          error={!!errors.introVideoUrl}
          helperText={errors.introVideoUrl}
        />
      </div>
    </SectionCard>
  );
});
